import { cn } from "@nextui-org/react";
import React, { useState, useEffect } from "react";

export const AmbientColor = () => {
  const showRadialGradient = true;
  // Delay animation start to not block initial render
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    // Start animation after initial paint
    const timer = requestIdleCallback(() => setShouldAnimate(true), { timeout: 1000 });
    return () => cancelIdleCallback(timer);
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden dark">
      <div
        className={cn(
          `
            [--aurora:repeating-linear-gradient(100deg,var(--fuchsia-600)_10%,var(--pink-600)_15%,var(--fuchsia-700)_20%,var(--pink-600)_25%,var(--fuchsia-600)_30%)]
            [background-image:var(--aurora)]
            dark:[background-image:var(--aurora)]
            [background-size:200%]
            [background-position:50%_50%]
            pointer-events-none
            absolute -inset-[10px] opacity-50`,
          // Only apply expensive effects after initial render
          shouldAnimate && `filter blur-[10px] invert dark:invert-0
            after:content-[""] after:absolute after:inset-0 after:[background-image:var(--aurora)]
            after:dark:[background-image:var(--aurora)]
            after:[background-size:200%]
            after:animate-aurora after:[background-attachment:fixed] after:mix-blend-difference`,
          showRadialGradient &&
            `[mask-image:radial-gradient(ellipse_at_100%_0%,black_10%,var(--transparent)_70%)]`
        )}
      ></div>
    </div>
  );
};
